'use strict';

module.exports = require('./lib/utf8-binary-cutter');
